import React , {Fragment} from "react";
import * as s from "./CreateTask.style";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../../../../components/shared/inputs/FormikControl";
import Spinner from '../../../../components/shared/spinner/Spinner';
// images
import logo from "../../../../assets/images/logo.png";

import * as actions from "../../../../store/actions/index";
import {  useSelector, useDispatch } from "react-redux";
import { useParams, useHistory , useLocation } from "react-router-dom";

const CreateTask = (props) => {

  const initialValues = {
    name: "",
    description: "",
  
  };
  const validationSchema = Yup.object({
    name: Yup.string().required("Required"),
    description: Yup.string().required("Required"),
    
  });

  let projectID = useSelector((state) => state.forMilestones.projectId);
  console.log(projectID)


  let dispatch = useDispatch();
  const history = useHistory();

  const onSubmit = (values) => {
    console.log("Form data", values);
    dispatch(actions.createProjectMilestone(projectID,values , () => history.goBack()))
  };

  let taskLoading = useSelector((state) => state.forMilestones.loading);
  console.log(taskLoading);
  return (
    <s.ScreenContainer>
      <s.Container>
      {taskLoading === false ? (
        <Fragment>
        
        <s.LogoContainer>
          <s.LogoImage src={logo} />
          
        </s.LogoContainer>
        
        <s.FormContainer>
          
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {(formik) => {
              return (
               
                
                <Form>
                  <s.H1>Create new task</s.H1>
                  <s.InputContainer>
                    <FormikControl
                     
                      control="input"
                      // control='chakraInput'
                      type="text"
                      name="name"
                      placeholder="TASK NAME"
                    />
                    
                  
                    
                    <FormikControl
                      control="input"
                      // control='chakraInput'
                      type="text"
                      name="description"
                      placeholder="TASK DISCRIPTION"
                    />
                    
                  </s.InputContainer>
                 
                  
                  <s.Div>
                    <s.CreateBtn type="submit" disabled={!formik.isValid}>
                      Create
                    </s.CreateBtn>
                  </s.Div>
                </Form>
              );
            }}
          </Formik>
        </s.FormContainer>
      
      </Fragment>
      ) : (
        <s.SpinnerContainer>
        <Spinner />
      </s.SpinnerContainer>
      )}
      </s.Container>
    </s.ScreenContainer>
  );
};

export default CreateTask;
